import React from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { ECommerce, PaymentDetails } from "../../../Constant";
import { Container, Row } from "reactstrap";
import CreditCard from "./CreditCard";
import DebitCard from "./DebitCard";
import CodForm from "./CodForm";
import EmiForm from "./EmiForm";
import NetBanking from "./NetBanking";

const PaymentDetailsContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={PaymentDetails} parent={ECommerce} title={PaymentDetails} />
      <Container fluid className="credit-card">
      <Row>
        <CreditCard/>
        <DebitCard/>
        <CodForm/>
        <EmiForm/>
        <NetBanking/>
      </Row>
      </Container>
    </>
  );
};

export default PaymentDetailsContainer;
